import { Component, OnInit, Inject, ChangeDetectorRef } from '@angular/core';
import { SelectionModel } from '@angular/cdk/collections';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { EditProductComponent } from '../edit-product.component';
import { ToastrService } from 'ngx-toastr';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { map, debounceTime } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { WarehouseService } from '@app/api/api';

@Component({
  selector: 'meu-modal-choose-warehouse',
  templateUrl: './modal-choose-warehouse.component.html',
  styleUrls: ['./modal-choose-warehouse.component.scss'],
})
export class ModalChooseWarehouseComponent implements OnInit {
  listWarehouse = [];
  listlistWarehouseDataSearch = [];

  public controlSearch: FormControl = new FormControl();
  public keyUp = new Subject<KeyboardEvent>();
  dataSearchBasic: any = '';
  filter = '';
  totalPage = 0;
  page = 1;

  displayedColumns: string[] = ['index', 'name', 'code', 'address', 'action'];
  totalWarehouse: any;
  pagesize = 10;
  pageIndex = 1;

  pageSizeOptions: number[] = [5, 10, 20, 100];

  selection = new SelectionModel<Element>(true, []);

  itemWarehouse;

  constructor(
    public dialogRef: MatDialogRef<EditProductComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private toastr: ToastrService,
    private warehouseService: WarehouseService,
    private changeDetectorRef: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.keyUp
      .pipe(
        map((event) => event),
        debounceTime(300)
      )
      .subscribe((value) => {
        this.dataSearchBasic = value;
        this.filter = 'name@=*' + this.dataSearchBasic;
        this.page = 1;
        this.listlistWarehouseDataSearch = [];
        this.getListWarehouseDataSearch();
      });
    this.getListWarehouseDataSearch();

    if (this.data.listWarehouse.length > 0) {
      this.listWarehouse = this.data.listWarehouse;
      this.totalWarehouse = this.listWarehouse.length;
    }
  }

  getListWarehouseDataSearch() {
    this.warehouseService.apiWarehousesGet(this.filter, '', this.page, 10).subscribe((res) => {
      if (res.success) {
        this.totalPage = Math.ceil(res.data.total / 10);
        for (let i = 0; i < res.data.collection.length; i++) {
          let index = this.listlistWarehouseDataSearch.findIndex(
            (x) => x.id == res.data.collection[i].id
          );
          if (index == -1) {
            this.listlistWarehouseDataSearch.push({
              id: res.data.collection[i].id,
              name: res.data.collection[i].name,
              code: res.data.collection[i].code,
              address: res.data.collection[i].address,
            });
          }
        }
      }
      this.changeDetectorRef.detectChanges();
    });
  }

  loadMore(e) {
    this.page = this.page + 1;
    this.getListWarehouseDataSearch();
  }

  search(event) {}

  deleteWarehouse(id) {
    let index = this.listWarehouse.findIndex((x) => x.id == id);
    if (index > -1) {
      this.listWarehouse.splice(index, 1);
      this.listWarehouse = [...this.listWarehouse];
      this.totalWarehouse = this.listWarehouse.length;
      this.changeDetectorRef.detectChanges();
    }
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.listWarehouse.length;
    return numSelected === numRows;
  }

  masterToggle() {
    this.isAllSelected()
      ? this.selection.clear()
      : this.listWarehouse.forEach((row) => this.selection.select(row));
  }

  closeModal() {
    this.dialogRef.close({ event: false });
  }

  save() {
    let listWarehouseResult = this.listWarehouse;
    for (let i = 0; i < listWarehouseResult.length; i++) {
      listWarehouseResult[i]['quantity'] = 0;
      listWarehouseResult[i]['SKUCode'] = '';
    }
    this.dialogRef.close({ event: true, data: listWarehouseResult });
  }

  addWarehouse() {
    if (!this.itemWarehouse) {
      this.toastr.warning('Vui lòng chọn một kho hàng');
      return;
    }
    let obj: any = this.itemWarehouse;
    obj['index'] = this.listWarehouse.length;

    let item = this.listWarehouse.find((x) => x.id == obj['id']);
    if (item) {
      this.toastr.warning('Kho hàng này đã được chọn');
      return;
    }

    this.listWarehouse.push(obj);
    this.listWarehouse = [...this.listWarehouse];
    this.totalWarehouse = this.listWarehouse.length;
    this.changeDetectorRef.detectChanges();
  }

  onPageChange(pageNumber: number) {
    if (typeof pageNumber === 'number') {
      this.pageIndex = pageNumber;
    }
  }

  onPageSizeChange(newSize: number) {
    this.pagesize = newSize;
    this.pageIndex = 1;
  }
}
